// History Swiper
const years = [2010, 2013, 2020, 2024];

var swiper = new Swiper(".mySwiperHistory", {
  cssMode: true,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,

    renderBullet: (index, className) => {
      return `
        <span class="${className} relative flex flex-col items-center">
          <span class="year-span-active">${years[index]}</span>
          <span class="year-span">${years[index]}</span>
        </span>`;
    },
  },
});
